// Mock data per Social Media Agency

export const services = [
  {
    id: '01',
    title: 'Social Media Management',
    description: 'Gestione completa dei tuoi account social con strategie data-driven per massimizzare engagement e conversioni.',
    services: [
      'Strategia & Content Planning',
      'Community Management 24/7',
      'Analytics & Reporting',
      'Growth & Engagement'
    ],
    link: '/servizi/social-media-management'
  },
  {
    id: '02',
    title: 'Lead Generation',
    description: 'Campagne mirate per generare lead qualificati e aumentare le vendite attraverso strategie di marketing avanzate.',
    services: [
      'Campagne Ads Mirate',
      'Funnel Optimization',
      'A/B Testing & Analytics',
      'CRM Integration'
    ],
    link: '/servizi/lead-generation'
  },
  {
    id: '03',
    title: 'Content Creation',
    description: 'Contenuti professionali che catturano l\'attenzione: video, grafiche, copy e storytelling per il tuo brand.',
    services: [
      'Video Production',
      'Graphic Design',
      'Copywriting Professionale',
      'Brand Storytelling'
    ],
    link: '/servizi/content-creation'
  },
  {
    id: '04',
    title: 'Influencer Marketing',
    description: 'Collaborazioni strategiche con influencer per amplificare il tuo messaggio e raggiungere nuovi pubblici.',
    services: [
      'Selezione Influencer',
      'Campaign Management',
      'ROI Tracking',
      'Contract Negotiation'
    ],
    link: '/servizi/influencer-marketing'
  },
  {
    id: '05',
    title: 'Supporto Legale',
    description: 'Tutela completa per creator: gestione contenziosi, protezione IP, contratti e difesa da plagio e haters.',
    services: [
      'Tutela Copyright & IP',
      'Gestione Contenziosi',
      'Contract Management',
      'Crisis Management'
    ],
    link: '/servizi/supporto-legale'
  },
  {
    id: '06',
    title: 'Business Administration',
    description: 'Gestione completa amministrativa, finanziaria e contabile per permetterti di concentrarti sul contenuto.',
    services: [
      'Gestione Amministrativa',
      'Consulenza Finanziaria',
      'Contabilità & Fiscale',
      'Budget Planning'
    ],
    link: '/servizi/business-administration'
  }
];

export const caseStudies = [
  {
    id: 1,
    title: 'Fitness Influencer',
    category: 'Content Creation and Social Media Management',
    tags: ['Lead Generation', 'Content Management', '24/7 Community Management', 'Instagram Growth', 'YouTube ADS', 'Legal Support'],
    image: 'https://images.unsplash.com/photo-1671581084367-1bf522951eae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGd5bSUyMHdvcmtvdXR8ZW58MHx8fHwxNzcyNDYwNjkyfDA&ixlib=rb-4.1.0&q=85',
    results: '+ Lead Qualificati, + ROI Advertising, + Engagement Rate',
    link: '/case-study/fitness-influencer'
  },
  {
    id: 2,
    title: 'Food & Beverage',
    category: 'Conversion Optimization and Social Media Management',
    tags: ['Social Strategy', 'B2B and B2C Marketing', 'Lead Generation', 'Content Management', '24/7 Community Management'],
    image: 'https://images.unsplash.com/photo-1765850258622-9d9afa7cf4e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHx3aW5lJTIwY2VsbGFyJTIwYm90dGxlc3xlbnwwfHx8fDE3NzI0NjA2OTd8MA&ixlib=rb-4.1.0&q=85',
    results: '+ Vendite, + Engagement Rate, + Brand Positioning',
    link: '/case-study/food-beverage'
  },
  {
    id: 3,
    title: 'Fashion Brand',
    category: 'Social Media Management and Content Strategy',
    tags: ['Lead Generation', 'Content Management', 'Legal Support', '24/7 Community Management', 'Conversion Optimization', 'Brand Consolidation'],
    image: 'https://images.unsplash.com/photo-1762430815620-fcca603c240c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwcnVud2F5JTIwc2hvd3xlbnwwfHx8fDE3NzI0NjA3MDN8MA&ixlib=rb-4.1.0&q=85',
    results: '+ Engagement Rate, + Lead Qualificati, + Engagement Rate',
    link: '/case-study/fashion-brand'
  }
];

export const stats = [
  {
    value: '+250%',
    label: 'Conversioni medie',
    sublabel: 'dopo 30 giorni'
  },
  {
    value: '100%',
    label: 'Clienti soddisfatti',
    sublabel: 'dopo 30 giorni'
  },
  {
    value: '24/7',
    label: 'Copertura e Supporto',
    sublabel: 'garantiti'
  }
];

export const clients = [
  'Meta', 'Google', 'TikTok', 'Instagram', 'LinkedIn', 'YouTube', 'Twitter', 'Pinterest'
];